import { I18n } from "aws-amplify/utils"
import { useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import LinkMachineForm from "../../components/onboarding/LinkMachineForm"
import { UserDataContext, UserDataContextHelper } from "../../contexts"
import { getLinkToVehicleOverview } from "../../LinkUtils"

/**
 * Links a machine to an org, on a page of its own.
 *
 * A page rather than a banner or a modal: accepting the EU Data Act terms is
 * tied to a terms version, so it belongs somewhere stable that has a URL —
 * support can send it, the user can revisit it, and a stray click cannot
 * discard what was entered.
 *
 * Reached from the onboarding slot, and later from the machines list.
 * `OrgRouteGuard` has already checked that the org id is one of the user's.
 *
 * @route /orgs/:orgId/link-machine
 */
export default function LinkMachine() {
  const params = useParams<{ orgId: string }>()
  const navigate = useNavigate()
  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.tryFindOrg(params.orgId, userData)

  if (!org) {
    // The guard redirects in this case; this is only for the render before it
    return null
  }

  return (
    <div className="rm-list-page">
      <h2>{I18n.get("Maschine verknüpfen")}</h2>
      {/* `replace` keeps the back button from returning to a form whose job
          is done. */}
      <LinkMachineForm
        orgId={org.id}
        onLinked={(vin) =>
          navigate(getLinkToVehicleOverview({ vin }), { replace: true })
        }
      />
    </div>
  )
}
